import * as React from 'react';
import { useState, useEffect } from 'react';
import { useFragment } from 'react-relay';

import { profilePictureFragment } from './ProfilePicture.relay';
import type { ProfilePicturePropsType } from './types';

const fallbackUrl = '/static/front/assets/profile/gm_fallback.png';

const ProfilePicture: React.FC<ProfilePicturePropsType> = ( props ) => {
    const pictureData = useFragment( profilePictureFragment, props.picture );

    const [ resolved, setResolved ] = useState( !pictureData );
    const [ pictureUrl, setPictureUrl ] = useState( pictureData ? '' : fallbackUrl );

    useEffect( () => {
        if ( !pictureData ) {
            setResolved( true );
            setPictureUrl( fallbackUrl );
            return;
        }

        const img = new Image();
        const resolve = ( err?: boolean ) => {
            let newUrl = fallbackUrl;
            if ( !err && pictureData.url ) {
                newUrl = pictureData.url;
            }

            setResolved( true );
            setPictureUrl( newUrl );
        };

        img.onerror = () => resolve( true );
        img.onload = () => resolve( false );
        if ( pictureData.url ) {
            img.src = pictureData.url;
        } else {
            resolve( true );
        }
    }, [ pictureData ] );

    return (
        <div className={ `relative z-100 mx-auto flex h-[177px] w-[177px] items-center justify-center overflow-hidden rounded-full transition-opacity duration-500 ${ resolved ? 'opacity-100' : 'opacity-0' }` }>
            {resolved ? <img className='h-auto w-full' src={ pictureUrl } alt={ props.managername } /> : null}
        </div>
    );
};

export { ProfilePicture };
